<template>
  <div class="main">
    <div class="top-title">
      <div class="title-content">
        <van-icon name="wechat" color="#FFFFFF" size="20"/>
        <span class="title-text">{{title}}</span>
      </div>
      <div class="top-actions">
        <van-button v-if="form.Role === 'passenger' && form._id && form.DriverId" size="mini" round @click="cancleBind">取消绑定</van-button>
        <van-button v-if="form._id" size="mini" round @click="reregister">重新注册</van-button>
      </div>
    </div>
    <div class="content-body">
      <div v-if="pageLoading" class="page-loading">
        <van-loading size="24px" vertical>加载中...</van-loading>
      </div>
      <template v-else>
      <div class="card">
        <div class="cell-flex" style="justify-content: space-between;">
          <div style="font-size: 16px;font-weight: 600;">每日提醒</div>
          <div v-if="needBind" class="cell-flex card-msg" @click="goTo('audit')">
            <van-icon name="send-gift" color="#F22222" size="18"/>
            <div style="margin: 0 4px;">你有新的拼车请求!</div>
            <van-icon name="arrow" style="margin-left: 20px;"/>
          </div>
        </div>
        <div style="margin-top: 10px;">
          <template v-if="form.Status || havingTravel">
            <div class="driver-time" @click="showDate = true">
              <div class="cell-flex">
                <a style="width: 50px;">{{form.Role === 'driver' ? '出发' : '上车'}}</a>
                <a style="font-size: 14px;">{{time}}</a>
                <a style="color: #999999;font-size: 14px;margin-left: 6px;">( {{date}}  {{week}} )</a>
              </div>
              <van-icon name="arrow" color="#D2D2D2"/>
            </div>
            <van-calendar
              v-model="showDate"
              :default-date="null"
              color="#FEB013"
              get-container="body"
              :show-confirm="false"
              safe-area-inset-bottom
              :min-date="minDate"
              :max-date="maxDate"
              @select="onCalendarSelect" />
            <van-popup v-model="showTime" position="bottom" round>
              <van-datetime-picker
                v-model="time"
                type="time"
                title="选择发车时间"
                :min-hour="6"
                :max-hour="8"
                @confirm="onTime"
                @cancel="showTime = false"
              />
            </van-popup>
            <div class="driver-way">
              <a style="display: table;width: 50px;">{{form.Role === 'driver' ? '途径' : '地点'}}</a>
              <div style="font-size: 14px;">{{form.Way || '未设置地点'}}</div>
            </div>

            <!-- 司机端操作区 -->
            <template v-if="form.Role === 'driver'">
              <template v-if="driverBtn">
                <div class="driver-action-box">
                  <div v-if="qrUnavailableReason" class="driver-wait-tip driver-dayoff-tip">{{ qrUnavailableReason }}</div>
                  <van-button
                    block
                    round
                    size="large"
                    icon="qr"
                    color="#FEB013"
                    class="main-scan-btn"
                    :disabled="!!qrUnavailableReason"
                    @click="openQRCodeModal"
                  >
                    出示动态乘车码
                  </van-button>
                  <div class="sub-action-row">
                    <van-button plain round size="small" class="sub-action-btn" @click="driverCancle">{{ isTomorrowSelected ? '取消预约' : '取消发车' }}</van-button>
                    <van-button v-if="isTodaySelected" round size="small" color="#333333" class="sub-action-btn" @click="checkDriver">确认发车</van-button>
                  </div>
                </div>
              </template>
              <template v-else>
                <div class="driver-action-box">
                  <div class="driver-wait-tip driver-dayoff-tip" v-if="manualStartTipDanger">{{ manualStartTip }}</div>
                  <div class="driver-wait-tip" v-else>{{ manualStartTip }}</div>
                  <van-button
                    v-if="showManualStart"
                    block
                    round
                    color="#FEB013"
                    class="main-scan-btn"
                    :loading="manualTravelLoading"
                    @click="manualStartTodayTravel"
                  >
                    {{ manualStartButtonText }}
                  </van-button>
                </div>
              </template>
            </template>

            <!-- 乘客端操作区 -->
            <template v-else>
              <div v-if="form.DriverName || form.DriverCarNum" class="driver-info driver-card">
                <div class="cell-flex">
                  <van-image round width="34px" height="34px" :src="form.DriverAvatar" />
                  <div style="padding-left: 12px;">
                    <div>{{form.DriverName}} {{form.DriverCarNum}}</div>
                    <div>
                      <a>({{form.DriverCarName || '车辆'}} | {{form.DriverCarSeat || '4'}}座)</a>
                    </div>
                  </div>
                </div>
                <a style="text-align: center;color: black;" :href="'tel://' + form.DriverPhone">
                  <van-icon name="phone" color="#FEB013" size="24"/>
                  <div>联系司机</div>
                </a>
              </div>

              <!-- 状态 1: 乘客已上车（签到成功） -->
              <template v-if="havingTravel && passengerTravelStatus === '已上车'">
                <div class="passenger-action-box">
                  <van-button block round size="large" color="#07c160" icon="checked" disabled class="boarded-btn">
                    已上车 (扫码签到成功)
                  </van-button>
                </div>
              </template>

              <!-- 乘客未上车：统一扫码入口 -->
              <template v-else>
                <div class="passenger-action-box">
                  <van-button
                    block
                    round
                    size="large"
                    icon="qr"
                    color="#FEB013"
                    class="main-scan-btn"
                    :loading="scanningLoading"
                    @click="onScanBoarding"
                  >
                    {{ havingTravel ? '扫码上车' : '扫码直接上车' }}
                  </van-button>
                </div>
              </template>
            </template>
            <div class="driver-text" v-if="form.Role === 'driver' && form.UserId">可在下方「发车设置」中提前配置自动发车与不发车日期</div>
            <div class="driver-text" v-else-if="havingTravel && passengerTravelStatus === '已上车'">您已成功扫码签到，祝您乘车愉快！</div>
            <div class="driver-text" v-else-if="havingTravel">司机行程已就绪，上车后请扫描司机出示的乘车码（08:30 前有效）</div>
            <div class="driver-text" v-else>未绑定固定路线？可直接扫描司机动态乘车码打卡上车</div>
          </template>
          <template v-else>
            <div class="passenger-action-box" style="padding: 16px 0 8px;">
              <div style="text-align: center; color: #888; font-size: 13px; margin-bottom: 12px;">
                未绑定固定司机？可直接扫描司机动态码上车
              </div>
              <van-button
                block
                round
                size="large"
                icon="qr"
                color="#FEB013"
                class="main-scan-btn"
                :loading="scanningLoading"
                @click="onScanBoarding"
              >
                扫码直接上车
              </van-button>
            </div>
          </template>
        </div>
      </div>
      <template v-if="form.Role === 'driver' && form.UserId">
        <div class="card driver-depart-settings">
          <div class="settings-title">发车设置</div>
          <div class="driver-dayoff-row">
            <div>
              <div class="driver-dayoff-label">工作日自动发车</div>
              <div class="driver-dayoff-desc">开启后工作日 06:00 自动发起行程并通知乘客</div>
            </div>
            <van-switch
              v-model="autoDepart"
              size="22px"
              active-color="#FEB013"
              :loading="autoDepartLoading || !autoDepartConfigLoaded"
              :disabled="!autoDepartConfigLoaded"
              @change="onAutoDepartChange"
            />
          </div>
          <div class="skip-dates-section">
            <div class="skip-dates-header">
              <span class="skip-dates-title">不发车日期</span>
              <van-button size="mini" round color="#FEB013" @click.stop="openSkipCalendar">添加日期</van-button>
            </div>
            <div v-if="skipDates.length" class="skip-dates-list">
              <div v-for="d in skipDates" :key="d" class="skip-date-tag">
                <span>{{ d }} {{ formatWeekday(d) }}</span>
                <van-icon name="cross" class="skip-date-remove" @click="removeSkipDate(d)" />
              </div>
            </div>
            <div v-else class="skip-dates-empty">可提前添加请假、出差等不发车日期</div>
          </div>
        </div>
        <div v-if="passengerList.length > 0" style="font-size: 14px;">以下是已绑定的乘客列表</div>
        <div v-for="(item, key) in passengerList" :key="key" class="passenger">
          <div class="cell-flex">
            <van-image round width="30px" height="30px" :src="item.Avatar" />
            <div style="margin-left: 10px;">
              <div style="font-weight: 600;"><van-icon name="location" size="15" color="#999999"/>{{item.Way}}</div>
              <div class="cell-flex">
                <div style="min-width: 45px;">{{item.Name}}</div>
                <div
                  v-if="item.TravelStatus"
                  class="passenger-status"
                  :style="item.TravelStatus === '已上车' ? 'background-color:#07c160;' : (item.TravelStatus === '已拼车' ? 'background-color:#39A0F4;' : 'background-color:#F22222;')"
                >{{item.TravelStatus}}</div>
              </div>
            </div>
          </div>
          <a style="text-align: center;color: #333333;" :href="'tel://' + item.Phone">
            <van-icon name="phone" size="25" color="#FEB013"/>
            <div style="font-size: 12px;">联系乘客</div>
          </a>
        </div>
      </template>
      <template v-else-if="form.Role === 'passenger'">
        <div style="font-size: 14px;">以下仅附近站点区域内的早拼推荐</div>
        <van-sticky>
          <van-search v-model="searchValue" background="#F5F5F5" placeholder="输入 站点或司机姓名 查询" @input="onSearchInput"/>
        </van-sticky>
        <div v-if="listLoading" class="list-loading">
          <van-loading size="24px" vertical>司机列表加载中...</van-loading>
        </div>
        <template v-else-if="driverList.length">
          <div v-for="(item, key) in driverList" :key="item._id || key" class="driver-list">
            <div class="driver-info">
              <div class="cell-flex">
                <van-image round width="34px" height="34px" :src="item.Avatar" />
                <div style="padding-left: 12px;">
                  <div>{{item.Name}} {{item.CarNum}}</div>
                  <div>
                    <a>({{item.CarName}} | {{item.CarSeat}}座)</a>
                    <a style="padding-left: 8px;color: red;">已拼{{item.passengerCount != null ? item.passengerCount : (item.passengers ? item.passengers.length : 0)}}人</a>
                  </div>
                </div>
              </div>
              <van-button :disabled="bindBtn" icon="coupon" round color="#333333" @click="goTo('bind', item.UserId)"> 绑 定 </van-button>
            </div>
            <div class="cell-flex driver-bottom">
              <van-icon name="location" color="#4DBE86"/>
              <div style="padding-left: 12px;">{{item.Way}}</div>
            </div>
          </div>
        </template>
        <div v-else class="list-empty">
          <van-empty description="暂无附近可绑定司机" />
        </div>
      </template>
      </template>
    </div>
    <div style="height: 5px;"></div>

    <!-- 司机动态乘车码弹窗 -->
    <van-popup
      v-model="showQRCodeModal"
      round
      closeable
      position="center"
      class="qr-modal-popup"
      :style="{ width: '88%', maxHeight: '85%' }"
      @close="closeQRCodeModal"
    >
      <div class="qr-modal-container">
        <div class="qr-modal-title">早班拼车动态乘车码</div>
        <div class="qr-modal-instruction">请让乘客扫描此动态二维码完成上车签到</div>

        <div class="qr-code-box">
          <div v-if="qrLoading && !qrCodeUrl" class="qr-loading-wrapper">
            <van-loading size="32px" vertical color="#FEB013">生成中...</van-loading>
          </div>
          <img v-else-if="qrCodeUrl" :src="qrCodeUrl" class="qr-code-img" alt="动态乘车码" />
          <div v-else class="qr-error-text">{{ qrErrorText || '乘车码加载失败' }}</div>
        </div>

        <div class="qr-countdown-bar">
          <van-icon name="clock-o" color="#FF9E04" size="14" style="margin-right: 4px;" />
          二维码将在 <span class="countdown-highlight">{{ qrCountdown }}</span> 秒后自动刷新
        </div>

        <div class="qr-passenger-section">
          <div class="qr-passenger-header">
            <span class="section-title">乘客签到状态</span>
            <span class="section-badge">已签到: {{ boardedCount }}/{{ passengerList.length }}</span>
          </div>
          <div class="qr-passenger-list">
            <div v-for="(item, key) in passengerList" :key="key" class="qr-passenger-item">
              <div class="cell-flex">
                <van-image round width="28px" height="28px" :src="item.Avatar" />
                <div class="qr-passenger-meta">
                  <div class="passenger-name">{{ item.Name }}</div>
                  <div class="passenger-way">{{ item.Way }}</div>
                </div>
              </div>
              <van-tag v-if="item.TravelStatus === '已上车'" type="success" round size="medium">已上车</van-tag>
              <van-tag v-else type="warning" round plain size="medium">待上车</van-tag>
            </div>
            <div v-if="!passengerList.length" class="qr-no-passenger">
              暂无已绑定乘客
            </div>
          </div>
        </div>
      </div>
    </van-popup>
    <van-calendar
      v-model="showSkipCalendar"
      title="选择不发车日期"
      color="#FEB013"
      get-container="body"
      :show-confirm="false"
      :min-date="skipCalendarMinDate"
      :max-date="skipCalendarMaxDate"
      :default-date="skipCalendarMinDate"
      safe-area-inset-bottom
      @confirm="onAddSkipDate"
    />
  </div>
</template>
<script>
import QRCode from 'qrcode'
import wx from 'weixin-js-sdk'
import * as ww from '@wecom/jssdk'

export default {
  data() {
    return {
        WXInfo: {},
        title: '',
        form: {},
        passengerList: [],
        driverList: [],
        showDate: false,
        showTime: false,
        minDate: new Date(),
        maxDate: this.$moment(new Date()).add(1,'days')._d,
        time: '07:30',
        date: '',
        week: this.$moment(new Date()).format('dddd'),
        needBind: false,
        bindBtn: false,
        driverBtn: false,
        travelLoading: false,
        passengerBtn: false,
        havingTravel: false,
        searchValue: '',
        passengerBtnText: '',
        passengerTravelStatus: null,
        boardPerson: [],
        pageLoading: true,
        listLoading: false,
        searchTimer: null,
        // 二维码相关
        showQRCodeModal: false,
        qrCodeUrl: '',
        qrLoading: false,
        qrCountdown: 30,
        qrCountdownTimer: null,
        passengerPollTimer: null,
        scanningLoading: false,
        isWxReady: false,
        autoDepart: true,
        autoDepartLoading: false,
        autoDepartConfigLoaded: false,
        suppressAutoDepartChange: false,
        skipDates: [],
        todaySkipped: false,
        showSkipCalendar: false,
        skipCalendarMinDate: new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate()),
        skipCalendarMaxDate: new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate() + 90),
        manualTravelLoading: false,
        qrErrorText: '',
        currentTime: Date.now(),
        boardingClockTimer: null
    }
  },
  computed: {
    boardedCount() {
      return (this.passengerList || []).filter(item => item.TravelStatus === '已上车').length
    },
    todayStr() {
      return this.$moment(this.currentTime).format('YYYY-MM-DD')
    },
    /** 当前是否在乘车码开放时段 06:00-08:30 */
    isBoardingWindowOpen() {
      const now = this.$moment(this.currentTime)
      const start = this.$moment(this.todayStr + ' 06:00')
      const end = this.$moment(this.todayStr + ' 08:30')
      return !now.isBefore(start) && !now.isAfter(end)
    },
    canStartTodayTravel() {
      return !this.$moment(this.currentTime).isAfter(this.$moment(this.todayStr + ' 08:30'))
    },
    tomorrowStr() {
      return this.$moment(this.todayStr + ' 00:00:00').add(1, 'days').format('YYYY-MM-DD')
    },
    isTodaySelected() {
      return this.date === this.todayStr
    },
    isTomorrowSelected() {
      return this.date === this.tomorrowStr
    },
    selectedDateSkipped() {
      return this.skipDates.includes(this.date)
    },
    targetTravelDate() {
      if (this.isTomorrowSelected) return this.date
      if (this.canStartTodayTravel) return this.todayStr
      return this.tomorrowStr
    },
    showManualStart() {
      if (this.driverBtn) return false
      return !this.skipDates.includes(this.targetTravelDate)
    },
    manualStartButtonText() {
      return this.targetTravelDate === this.tomorrowStr ? '预约明天拼车' : '手动发起今日行程'
    },
    manualStartTip() {
      if (this.isTomorrowSelected) {
        if (this.selectedDateSkipped) return '明天在不发车日期内，请先移除该日期后再预约'
        return '可提前预约明天拼车，乘客会收到通知；当天 06:00 后可出示乘车码'
      }
      if (!this.canStartTodayTravel) {
        if (this.skipDates.includes(this.tomorrowStr)) return '今日已超过 08:30，明天已设为不发车，如需补录请走异常补单'
        return '今日已超过 08:30 发起时限，可预约明天拼车，或走异常补单'
      }
      if (this.todaySkipped) return '今日在不发车日期内，不会自动发起；也可点击出发日期预约明天'
      if (this.autoDepart) return '工作日早晨 06:00 系统将自动发起今日行程，也可手动发起或预约明天'
      return '已关闭自动发车，可手动发起今日行程，或点击出发日期预约明天'
    },
    manualStartTipDanger() {
      if (this.isTomorrowSelected) return this.selectedDateSkipped
      if (!this.canStartTodayTravel) return true
      return this.todaySkipped
    },
    qrUnavailableReason() {
      if (this.form.Role !== 'driver') return ''
      if (!this.driverBtn || !this.travelId) {
        if (this.todaySkipped) return '今日在不发车日期内，不会生成行程'
        if (!this.autoDepart) return '已关闭自动发车，请先手动发起今日行程'
        return '今日行程尚未生成，请点击下方按钮发起'
      }
      if (this.isTomorrowSelected) return '明日行程已预约，当天 06:00 后可出示乘车码'
      if (!this.isTodaySelected) return '仅当天行程可出示乘车码'
      if (!this.isBoardingWindowOpen) {
        const now = this.$moment(this.currentTime)
        if (now.isBefore(this.$moment(this.todayStr + ' 06:00'))) {
          return '乘车码将于 06:00 开放'
        }
        return '已超过 08:30 乘车码时限，请走异常补单'
      }
      return ''
    }
  },
  beforeDestroy() {
    clearInterval(this.boardingClockTimer)
    document.removeEventListener('visibilitychange', this.updateBoardingClock)
    window.removeEventListener('focus', this.updateBoardingClock)
    if (this.searchTimer) {
      clearTimeout(this.searchTimer)
      this.searchTimer = null
    }
    this.clearQRTimers()
  },
  async mounted() {
    this.updateBoardingClock()
    this.boardingClockTimer = setInterval(this.updateBoardingClock, 1000)
    document.addEventListener('visibilitychange', this.updateBoardingClock)
    window.addEventListener('focus', this.updateBoardingClock)
    const userinfo = localStorage.getItem('userinfo')
    if (userinfo) {
      try {
        this.WXInfo = JSON.parse(userinfo).data || {}
        this.form.Name = this.WXInfo.name
        this.form.UserId = this.WXInfo.userid
        this.form.Phone = this.WXInfo.mobile
        const storedAutoDepart = this.readStoredAutoDepart(this.form.UserId)
        if (storedAutoDepart !== null) {
          this.applyAutoDepartValue(storedAutoDepart)
        }
      } catch (e) {
        this.WXInfo = {}
      }
    }
    // URL 扫码不依赖 JSSDK，优先完成核销；JSSDK 初始化与页面数据加载并行，避免签名接口拖慢页面
    const urlScanHandled = await this.checkAndHandleUrlScan()
    await Promise.all([
      this.initWxConfig(),
      urlScanHandled ? Promise.resolve() : this.getData()
    ])
  },
  methods: {
    updateBoardingClock() {
      const previousDay = this.todayStr
      this.currentTime = Date.now()
      if (this.showQRCodeModal && !this.isBoardingWindowOpen) this.closeQRCodeModal()
      if (previousDay !== this.todayStr && this.form.Role === 'driver' && this.form.UserId) {
        const start = this.$moment(this.currentTime).startOf('day')
        this.skipCalendarMinDate = start.toDate()
        this.skipCalendarMaxDate = start.clone().add(90, 'days').toDate()
        this.closeQRCodeModal()
        this.driverBtn = false
        this.travelId = ''
        this.todaySkipped = this.skipDates.includes(this.todayStr)
        this.minDate = start.toDate()
        this.maxDate = start.clone().add(1, 'days').toDate()
        Promise.all([this.loadDriverDepartConfig(), this.getWorkTravelApi(this.form.UserId)])
          .catch(error => console.warn('跨日刷新行程失败', error))
      }
    },
    async initWxConfig() {
      try {
        const result = await this.$request({
          method: 'GET',
          url: this.$api.getWXSign,
          params: {
            Url: window.location.href.split('#')[0]
          }
        })
        if (result.success && result.data) {
          const data = result.data
          const timestamp = data.timestamp
          const nonceStr = data.noncestr
          const signature = data.signature
          const corpSignature = data.corpSignature || signature
          const agentSignature = data.agentSignature || signature

          // 1. 注册企业微信专用 SDK (@wecom/jssdk)
          if (ww && ww.register) {
            try {
              ww.register({
                corpId: 'wxdf5df2adda0272b2',
                agentId: this.$agentid,
                jsApiList: ['scanQRCode', 'getLocation', 'shareAppMessage', 'shareWechatMessage'],
                async getConfigSignature() {
                  return { timestamp, nonceStr, signature: corpSignature }
                },
                async getAgentConfigSignature() {
                  return { timestamp, nonceStr, signature: agentSignature }
                }
              })
            } catch (wwErr) {
              console.warn('ww.register error:', wwErr)
            }
          }

          // 2. 注册微信 JS-SDK (weixin-js-sdk) 作为兼容
          if (wx && wx.config) {
            wx.config({
              beta: true,
              debug: false,
              appId: 'wxdf5df2adda0272b2',
              timestamp: timestamp,
              nonceStr: nonceStr,
              signature: corpSignature,
              jsApiList: ['scanQRCode', 'getLocation']
            })
            wx.ready(() => {
              this.isWxReady = true
              if (wx.agentConfig) {
                wx.agentConfig({
                  corpid: 'wxdf5df2adda0272b2',
                  agentid: this.$agentid,
                  timestamp: timestamp,
                  nonceStr: nonceStr,
                  signature: agentSignature,
                  jsApiList: ['scanQRCode', 'getLocation'],
                  success: () => {},
                  fail: (err) => {
                    console.warn('wx.agentConfig error:', err)
                  }
                })
              }
            })
            wx.error((err) => {
              console.warn('wx.config error:', err)
            })
          }
        }
      } catch (e) {
        console.error('initWxConfig error', e)
      }
    },
    async getData () {
      this.pageLoading = true
      try {
        await this.getUserInfo()
        if (this.form.Role === 'driver') {
          this.fillDefaultDepartDisplay()
          this.syncDriverTitle()
          const passengerRes = await this.getPassengerList()
          this.passengerList = passengerRes.data || []
          this.applyAutoDepartFromForm()
          await this.loadDriverDepartConfig()
          await this.getWorkTravelApi(this.form.UserId)
          this.syncDriverTitle()
          this.getNeedBindData()
        } else if (this.form.Role === 'passenger') {
          // 1. 优先检查乘客今天是否已有上车/拼车打卡记录（支持扫码直接拼车及临时乘车）
          const today = this.$moment().format('YYYY-MM-DD')
          let hasTodayPassengerRecord = false
          try {
            const currentUid = this.form.UserId || (this.WXInfo && this.WXInfo.userid) || localStorage.getItem('UserId')
            if (currentUid) {
              const todayRes = await this.getWorkTravelFromPassenger({
                UserId: currentUid,
                DateTime: today
              })
              if (todayRes && todayRes.data && todayRes.data.length) {
                const myToday = todayRes.data.find(d => d.Effect !== false) || todayRes.data[0]
                if (myToday && myToday.ParentsId) {
                  hasTodayPassengerRecord = true
                  await this.loadTravelById(myToday.ParentsId, myToday.Status)
                }
              }
            }
          } catch (e) {
            console.warn('check today passenger record error', e)
          }

          // 绑定状态必须每次重算：即使今天已扫码（hasTodayPassengerRecord=true），
          // 取消绑定后也不能沿用上一次的 bindBtn=true，否则司机列表的“绑定”按钮全部禁用
          this.bindBtn = false
          this.driverBtn = false
          if (this.form.DriverId && !this.form.Effictive) {
            this.bindBtn = true
            if (!hasTodayPassengerRecord) this.title = '等待司机确认...'
          } else if (this.form.DriverId && this.form.Effictive && !this.form.Status) {
            this.bindBtn = true
            if (!hasTodayPassengerRecord) this.title = '等待后台审核确认...'
          } else if (this.form.Effictive && this.form.Status && this.form.DriverId) {
            this.bindBtn = true
            this.driverBtn = true
            if (!hasTodayPassengerRecord) {
              this.title = '绑定生效中...'
              this.time = this.form.DepartTime
              await this.getTravel(this.form.DriverId)
            }
          } else if (!hasTodayPassengerRecord) {
            this.title = '请选择合适的路线绑定或直接扫码上车'
          }
          this.getDriverList()
        }
      } finally {
        this.pageLoading = false
      }
    },
    fillDefaultDepartDisplay() {
      if (!this.date || this.date === '0000-00-00') {
        this.date = this.todayStr
      }
      this.week = this.$moment(this.date).format('dddd')
      this.time = this.form.DepartTime || this.time || '07:30'
    },
    syncDriverTitle() {
      if (this.form.Role !== 'driver') return
      if (!this.form.Status) {
        if (!this.form.status && !this.form.Effictive) {
          this.title = '审核被拒绝，请联系王海苑'
        } else {
          this.title = '正在审核中，请耐心等待'
        }
        return
      }
      if (this.driverBtn && this.travelId) {
        this.title = this.isTomorrowSelected
          ? '明日行程已预约，当天早晨可出示乘车码'
          : '审核通过，请出示乘车码等待乘客扫码'
      } else if (this.isTomorrowSelected) {
        this.title = this.selectedDateSkipped ? '明天已设为不发车' : '可预约明天拼车'
      } else if (!this.canStartTodayTravel) {
        this.title = '今日行程未发起，可预约明天或走异常补单'
      } else if (this.todaySkipped) {
        this.title = '今日已设为不发车'
      } else if (this.autoDepart) {
        this.title = '审核通过，等待系统发起或可手动发起'
      } else {
        this.title = '审核通过，请手动发起今日行程'
      }
    },
    onSearchInput() {
      if (this.searchTimer) clearTimeout(this.searchTimer)
      this.searchTimer = setTimeout(() => {
        this.getDriverList()
      }, 300)
    },
    async manualStartTodayTravel() {
      this.updateBoardingClock()
      if (!this.form.UserId || this.manualTravelLoading) return
      const targetDate = this.targetTravelDate
      if (this.skipDates.includes(targetDate)) {
        this.$toast('该日在不发车日期内，请先移除该日期')
        return
      }
      if (targetDate === this.todayStr && !this.canStartTodayTravel) {
        this.$toast('已超过08:30发起时限，请预约明天或走异常补单流程')
        return
      }
      this.date = targetDate
      this.week = this.$moment(targetDate).format('dddd')
      this.manualTravelLoading = true
      this.$toast.loading({ message: '发起中...', forbidClick: true, duration: 0 })
      try {
        const result = await this.$request({
          url: this.$api.postManualWorkTravel,
          method: 'POST',
          data: { DateTime: targetDate }
        })
        this.$toast.clear()
        if (!result.success) {
          this.$toast(result.message || '发起失败')
          return
        }
        await this.getWorkTravelApi(this.form.UserId)
        this.$toast(targetDate === this.todayStr ? '今日行程已发起' : '明日行程已预约')
      } catch (e) {
        this.$toast('发起失败，请稍后重试')
        console.error('manualStartTodayTravel error', e)
      } finally {
        this.manualTravelLoading = false
      }
    },
    readStoredAutoDepart(userId) {
      if (!userId) return null
      const raw = localStorage.getItem('work_auto_depart_' + userId)
      if (raw === '0') return false
      if (raw === '1') return true
      return null
    },
    storeAutoDepart(userId, value) {
      if (!userId) return
      localStorage.setItem('work_auto_depart_' + userId, value ? '1' : '0')
    },
    applyAutoDepartValue(value) {
      const enabled = value !== false
      this.suppressAutoDepartChange = true
      this.autoDepart = enabled
      this.$nextTick(() => {
        this.suppressAutoDepartChange = false
      })
    },
    applyAutoDepartFromForm() {
      if (this.form.Role !== 'driver') return
      if (this.form.AutoDepart === false || this.form.AutoDepart === true) {
        this.applyAutoDepartValue(this.form.AutoDepart)
        return
      }
      if (this.form.autoDepart === false || this.form.autoDepart === true) {
        this.applyAutoDepartValue(this.form.autoDepart)
      }
    },
    async loadDriverDepartConfig() {
      if (this.form.Role !== 'driver' || !this.form.UserId) {
        this.autoDepartConfigLoaded = true
        return
      }
      try {
        const result = await this.$request({
          url: this.$api.getDriverDepartConfig,
          method: 'GET'
        })
        if (result && result.success && result.data && typeof result.data === 'object' && !Array.isArray(result.data)) {
          this.applyAutoDepartValue(result.data.autoDepart !== false)
          this.skipDates = result.data.skipDates || []
          this.todaySkipped = !!result.data.todaySkipped
          this.storeAutoDepart(this.form.UserId, result.data.autoDepart !== false)
          return
        }
        this.applyAutoDepartFromForm()
      } catch (e) {
        console.warn('loadDriverDepartConfig error', e)
        this.applyAutoDepartFromForm()
      } finally {
        this.autoDepartConfigLoaded = true
      }
    },
    async onAutoDepartChange(checked) {
      if (!this.form.UserId || this.autoDepartLoading || this.suppressAutoDepartChange) return
      this.autoDepartLoading = true
      const prev = !checked
      try {
        const result = await this.$request({
          url: this.$api.postDriverAutoDepart,
          method: 'POST',
          params: { autoDepart: checked ? 'true' : 'false' },
          data: { autoDepart: checked }
        })
        if (!result.success) {
          this.autoDepart = prev
          this.$toast(result.message || '设置失败')
          return
        }
        const saved = result.data && typeof result.data.autoDepart === 'boolean'
          ? result.data.autoDepart
          : checked
        this.applyAutoDepartValue(saved)
        this.form.AutoDepart = saved
        this.storeAutoDepart(this.form.UserId, saved)
        this.$toast(result.message || (checked ? '已开启自动发车' : '已关闭自动发车'))
      } catch (e) {
        this.autoDepart = prev
        this.$toast('设置失败，请稍后重试')
        console.error('onAutoDepartChange error', e)
      } finally {
        this.autoDepartLoading = false
      }
    },
    openSkipCalendar() {
      this.showSkipCalendar = true
    },
    async onAddSkipDate(date) {
      this.showSkipCalendar = false
      const dateStr = this.$moment(date).format('YYYY-MM-DD')
      if (this.skipDates.includes(dateStr)) {
        this.$toast('该日期已添加')
        return
      }
      try {
        const result = await this.$request({
          url: this.$api.postDriverSkipDate,
          method: 'POST',
          data: { DateTime: dateStr }
        })
        if (!result.success) {
          this.$toast(result.message || '添加失败')
          return
        }
        this.skipDates.push(dateStr)
        this.skipDates.sort()
        const today = this.$moment().format('YYYY-MM-DD')
        this.todaySkipped = this.skipDates.includes(today)
        this.$toast('已添加不发车日期')
        if (dateStr === this.date && this.form.UserId) {
          await this.getWorkTravelApi(this.form.UserId)
        }
      } catch (e) {
        this.$toast('添加失败，请稍后重试')
        console.error('onAddSkipDate error', e)
      }
    },
    async removeSkipDate(dateStr) {
      try {
        await this.$dialog.confirm({
          title: '提示',
          message: '确定移除 ' + dateStr + ' 的不发车设置？'
        })
        const result = await this.$request({
          url: this.$api.deleteDriverSkipDate,
          method: 'DELETE',
          params: { DateTime: dateStr }
        })
        if (!result.success) {
          this.$toast(result.message || '移除失败')
          return
        }
        this.skipDates = this.skipDates.filter(d => d !== dateStr)
        const today = this.$moment().format('YYYY-MM-DD')
        this.todaySkipped = this.skipDates.includes(today)
        this.$toast('已移除')
        if (dateStr === today || dateStr === this.date) {
          await this.getWorkTravelApi(this.form.UserId)
        }
      } catch (e) {
        if (e !== 'cancel') {
          this.$toast('操作失败')
        }
      }
    },
    formatWeekday(dateStr) {
      return this.$moment(dateStr).format('dddd')
    },
    // 司机取消行程
    driverCancle() {
      this.$dialog.confirm({
        title: '提示',
        message: this.isTomorrowSelected ? '是否取消明日预约？' : '是否取消行程？',
      })
        .then(async () => {
          const result = await this.deleteTravel(this.travelId)
          this.$toast(result.message)
          if (result.success) {
            this.driverBtn = false
            if (result.data && result.data.skipDateAdded) {
              await this.loadDriverDepartConfig()
            }
          }
        })
        .catch(() => {
          // on cancel
        })
    },
    // 打开动态乘车码弹窗
    async openQRCodeModal() {
      if (!this.travelId) {
        this.$toast('今日行程尚未生成，请先发起行程')
        return
      }
      if (this.qrUnavailableReason) {
        this.$toast(this.qrUnavailableReason)
        return
      }
      this.qrCodeUrl = ''
      this.qrErrorText = ''
      this.showQRCodeModal = true
      await this.fetchQRCode()
      this.startQRTimers()
      this.startPassengerPolling()
    },
    // 关闭动态乘车码弹窗
    closeQRCodeModal() {
      this.showQRCodeModal = false
      this.clearQRTimers()
    },
    // 拉取并生成二维码
    async fetchQRCode() {
      if (!this.travelId || !this.form.UserId) {
        this.qrErrorText = '行程信息未就绪，请返回刷新页面'
        return
      }
      this.qrLoading = true
      this.qrErrorText = ''
      try {
        const result = await this.$request({
          url: this.$api.getDynamicQRCode,
          method: 'GET',
          params: {
            TravelId: this.travelId,
            DriverId: this.form.UserId
          }
        })
        if (result.success && result.data && (result.data.scanUrl || result.data.token)) {
          const origin = window.location.origin || 'https://pinche.jafron.com'
          const scanUrl = result.data.scanUrl || `${origin}/work/index?scan_token=${encodeURIComponent(result.data.token)}`
          const url = await QRCode.toDataURL(scanUrl, {
            width: 220,
            margin: 1,
            color: {
              dark: '#222222',
              light: '#ffffff'
            }
          })
          this.qrCodeUrl = url
          this.qrCountdown = result.data.expireIn || 60
        } else {
          this.qrErrorText = result.message || '获取乘车码失败'
          this.$toast(this.qrErrorText)
        }
      } catch (e) {
        console.error('fetchQRCode error', e)
        this.qrErrorText = '网络异常，请稍后重试'
        this.$toast(this.qrErrorText)
      } finally {
        this.qrLoading = false
      }
    },
    // 启动二维码倒计时与定时刷新
    startQRTimers() {
      this.clearQRTimers()
      this.qrCountdownTimer = setInterval(() => {
        if (this.qrCountdown > 1) {
          this.qrCountdown--
        } else {
          this.fetchQRCode()
        }
      }, 1000)
    },
    // 轮询乘客签到状态
    startPassengerPolling() {
      if (this.passengerPollTimer) {
        clearInterval(this.passengerPollTimer)
      }
      this.pollPassengerStatus()
      this.passengerPollTimer = setInterval(() => {
        this.pollPassengerStatus()
      }, 5000)
    },
    async pollPassengerStatus() {
      if (!this.travelId) return
      try {
        const val = await this.getWorkTravelFromPassenger({ ParentsId: this.travelId })
        if (val && val.data) {
          this.refreshPassengerStatus(val.data)
        }
      } catch (e) {
        console.error('pollPassengerStatus error', e)
      }
    },
    // 清除定时器
    clearQRTimers() {
      if (this.qrCountdownTimer) {
        clearInterval(this.qrCountdownTimer)
        this.qrCountdownTimer = null
      }
      if (this.passengerPollTimer) {
        clearInterval(this.passengerPollTimer)
        this.passengerPollTimer = null
      }
    },
    // 校验是否可以发车
    checkDriver() {
      let nowDate = this.$moment(new Date()).format('YYYY-MM-DD')
      if (nowDate !== this.date) {
        this.$dialog.alert({
          title: '提示',
          message: '当前 ' + this.$moment(new Date()).format('YYYY-MM-DD HH:mm') + ' 时间，在非有效时间内，无法确认发车。'
        })
        return
      }
      this.getWorkTravelFromPassenger({ ParentsId: this.travelId }).then(val => {
        let list = (val.data || []).filter(item => item.Effect !== false)
        if (!list.length) {
          this.$toast('当前没有乘客扫码上车，无法发车。')
          return
        }
        this.refreshPassengerStatus(list)
        const boarded = list.filter(item => item.Status === '已上车')
        if (!boarded.length) {
          this.$toast('当前没有乘客扫码上车，无法发车。')
          return
        }
        this.boardPerson = boarded
        this.driverPostTravel()
      })
    },
    async driverPostTravel() {
      let data = { Status: '已发车' }
      const result = await this.postWorkTravel(data)
      if (result.success) {
        this.driverBtn = false
        this.$dialog.alert({ title: '提示', message: '今日拼车已完成~' })
        this.boardPerson.forEach(item => {
          this.sendMessage('driverConfirm', item.UserId, item)
        })
        this.passengerList.forEach(item => { this.$set(item, 'TravelStatus', '') })
      } else {
        this.$toast(result.message)
      }
    },
    // 司机刷新乘客状态（包括动态/扫码新增的乘客）
    refreshPassengerStatus(data) {
      if (!Array.isArray(data)) return
      data.forEach(ele => {
        let found = false
        this.passengerList.forEach(item => {
          if (ele.UserId === item.UserId) {
            this.$set(item, 'TravelStatus', ele.Status)
            found = true
          }
        })
        // 若乘客不在当前绑定的列表中（例如临时扫码打卡上车的其他同事），自动追加到司机界面的列表中
        if (!found && ele.UserId) {
          this.passengerList.push({
            UserId: ele.UserId,
            Name: ele.Name || '同行乘客',
            Phone: ele.Phone || '',
            Way: ele.Way || '随车上车',
            Avatar: ele.Avatar || '',
            TravelStatus: ele.Status || '已上车'
          })
        }
      })
    },
    // 乘客获取所有司机路线
    async getDriverList () {
      this.listLoading = true
      try {
        let query = {
          Role: 'driver',
          Effictive: true,
          Status: true,
          onlyAvailable: true
        }
        // 按当前用户区域过滤，避免拉全量司机
        if (this.WXInfo.area) {
          query.Area = this.WXInfo.area
        }
        const kw = (this.searchValue || '').trim()
        if (kw) {
          query.keyword = kw
        }
        let result = await this.getWorkDriverList(query)
        // 本区域没有匹配司机时回退到全区域，避免跨厂区/换片区时完全看不到可选司机
        if ((!result.data || !result.data.length) && query.Area) {
          const fallbackQuery = Object.assign({}, query)
          delete fallbackQuery.Area
          result = await this.getWorkDriverList(fallbackQuery)
        }
        if (result.data && result.data.length) {
          this.driverList = result.data
        } else {
          this.driverList = []
          if (result.message && kw) {
            this.$toast(result.message)
          }
        }
      } catch (e) {
        this.driverList = []
        console.error('getDriverList error', e)
      } finally {
        this.listLoading = false
      }
    },
    // 乘客取消行程：已移除，上车记录仅由扫码产生，不可手动取消
    // 获取GPS地理位置
    getGPSLocation() {
      return new Promise((resolve) => {
        const defaultLngLat = Array.isArray(this.form.LngLat) && this.form.LngLat.length === 2
          ? this.form.LngLat
          : [113.576726, 22.270715]
        const defaultAddress = this.form.Way || ''

        if (navigator && navigator.geolocation) {
          navigator.geolocation.getCurrentPosition(
            (pos) => {
              const lng = pos.coords.longitude
              const lat = pos.coords.latitude
              resolve({ lng, lat, address: defaultAddress })
            },
            (err) => {
              console.warn('getCurrentPosition error or permission denied:', err)
              resolve({ lng: defaultLngLat[0], lat: defaultLngLat[1], address: defaultAddress })
            },
            { timeout: 5000, enableHighAccuracy: true }
          )
        } else {
          resolve({ lng: defaultLngLat[0], lat: defaultLngLat[1], address: defaultAddress })
        }
      })
    },
    // 检查并处理通过微信/企微扫一扫直接打开页面的扫码签到
    async checkAndHandleUrlScan() {
      let scanToken = this.$route.query.scan_token || this.$route.query.token
      if (!scanToken && typeof window !== 'undefined' && window.location.search) {
        try {
          const urlParams = new URLSearchParams(window.location.search)
          scanToken = urlParams.get('scan_token') || urlParams.get('token')
        } catch (e) {
          console.warn('parse url params error', e)
        }
      }
      if (!scanToken) return false

      let token = String(scanToken).trim()
      if (token.includes('scan_token=')) {
        const match = token.match(/scan_token=([^&#\s]+)/)
        if (match) token = decodeURIComponent(match[1])
      } else if (token.includes('token=')) {
        const match = token.match(/token=([^&#\s]+)/)
        if (match) token = decodeURIComponent(match[1])
      }

      // 清理 URL 参数，避免用户刷新页面时再次触发扫码打卡
      try {
        const newQuery = { ...this.$route.query }
        delete newQuery.scan_token
        delete newQuery.token
        this.$router.replace({ path: this.$route.path, query: newQuery }).catch((err) => {
          console.warn('router replace error', err)
        })
      } catch (e) {
        console.warn('clear query error', e)
      }

      if (!token) return false

      this.$toast.loading({ message: '核验乘车码中...', forbidClick: true, duration: 0 })
      try {
        const loc = await this.getGPSLocation()

        const res = await this.$request({
          url: this.$api.scanConfirmBoarding,
          method: 'POST',
          data: {
            token: token,
            LngLat: [loc.lng, loc.lat],
            Address: loc.address || this.form.Way || ''
          }
        })
        this.$toast.clear()
        if (res && res.success) {
          if (res.data && res.data.driver) {
            const d = res.data.driver
            this.$set(this.form, 'DriverId', d.DriverId)
            this.$set(this.form, 'DriverName', d.DriverName)
            this.$set(this.form, 'DriverPhone', d.DriverPhone)
            this.$set(this.form, 'DriverAvatar', d.DriverAvatar)
            this.$set(this.form, 'DriverCarName', d.DriverCarName)
            this.$set(this.form, 'DriverCarNum', d.DriverCarNum)
            this.$set(this.form, 'DriverCarSeat', d.DriverCarSeat)
          }
          if (res.data && res.data.travel) {
            this.travelId = res.data.travel._id
            this.date = res.data.travel.DateTime
            this.time = res.data.travel.DepartTime
            this.week = this.$moment(res.data.travel.DateTime).format('dddd')
            this.$set(this.form, 'Way', res.data.travel.Way || this.form.Way || '')
          }
          this.passengerTravelStatus = '已上车'
          this.havingTravel = true
          this.passengerBtn = true
          this.title = '今日已成功扫码上车'

          await this.$dialog.alert({
            title: '乘车打卡成功',
            message: '已成功扫码签到，完成早班拼车上车！'
          })
          await this.getData()
          if (this.form.DriverId) {
            this.sendMessage('passengerBoard', this.form.DriverId, this.form)
          }
          return true
        } else {
          await this.$dialog.alert({
            title: '签到失败',
            message: (res && res.message) || '乘车码核销失败，请让司机出示最新二维码重新扫码'
          })
          return false
        }
      } catch (err) {
        this.$toast.clear()
        await this.$dialog.alert({
          title: '签到异常',
          message: err.message || '网络请求异常，请稍后重试'
        })
        return false
      }
    },
    // 乘客扫码上车
    async onScanBoarding() {
      if (this.scanningLoading) return
      this.scanningLoading = true
      try {
        const loc = await this.getGPSLocation()
        const doSubmitToken = async (rawToken) => {
          if (!rawToken) return
          let token = String(rawToken).trim()
          if (token.includes('scan_token=')) {
            const match = token.match(/scan_token=([^&#\s]+)/)
            if (match) token = decodeURIComponent(match[1])
          } else if (token.includes('token=')) {
            const match = token.match(/token=([^&#\s]+)/)
            if (match) token = decodeURIComponent(match[1])
          }
          if (!token) return

          this.$toast.loading({ message: '核验乘车码中...', forbidClick: true, duration: 0 })
          try {
            const res = await this.$request({
              url: this.$api.scanConfirmBoarding,
              method: 'POST',
              data: {
                token: token,
                LngLat: [loc.lng, loc.lat],
                Address: loc.address || this.form.Way || ''
              }
            })
            this.$toast.clear()
            if (res && res.success) {
              if (res.data && res.data.driver) {
                const d = res.data.driver
                this.$set(this.form, 'DriverId', d.DriverId)
                this.$set(this.form, 'DriverName', d.DriverName)
                this.$set(this.form, 'DriverPhone', d.DriverPhone)
                this.$set(this.form, 'DriverAvatar', d.DriverAvatar)
                this.$set(this.form, 'DriverCarName', d.DriverCarName)
                this.$set(this.form, 'DriverCarNum', d.DriverCarNum)
                this.$set(this.form, 'DriverCarSeat', d.DriverCarSeat)
              }
              if (res.data && res.data.travel) {
                this.travelId = res.data.travel._id
                this.date = res.data.travel.DateTime
                this.time = res.data.travel.DepartTime
                this.week = this.$moment(res.data.travel.DateTime).format('dddd')
                this.$set(this.form, 'Way', res.data.travel.Way || this.form.Way || '')
              }
              this.passengerTravelStatus = '已上车'
              this.havingTravel = true
              this.passengerBtn = true
              this.title = '今日已成功扫码上车'

              this.$dialog.alert({
                title: '乘车打卡成功',
                message: '已成功扫码签到，完成早班拼车上车！'
              }).then(() => {
                this.getData()
              })
              if (this.form.DriverId) {
                this.sendMessage('passengerBoard', this.form.DriverId, this.form)
              }
            } else {
              this.$dialog.alert({
                title: '签到失败',
                message: (res && res.message) || '乘车码核销失败'
              })
            }
          } catch (err) {
            this.$toast.clear()
            this.$toast(err.message || '网络请求失败')
          }
        }

        // 统一调用摄像头扫码；直到扫码流程真正结束（含核销完成）才解除 loading
        await this.invokeScanQRCode(doSubmitToken)
      } catch (e) {
        console.error('onScanBoarding error:', e)
        this.$toast('扫码启动异常')
      } finally {
        this.scanningLoading = false
      }
    },
    // 统一调起微信/企业微信摄像头扫码
    async waitForWxReady(timeout = 3000) {
      if (this.isWxReady) return
      const startedAt = Date.now()
      while (!this.isWxReady && Date.now() - startedAt < timeout) {
        await new Promise(resolve => setTimeout(resolve, 100))
      }
    },
    async invokeScanQRCode(callback) {
      await this.waitForWxReady()
      return new Promise((resolve) => {
        let finished = false
        const handleResult = (rawStr) => {
          if (finished) return
          finished = true
          if (rawStr) {
            // 改为 await 回调内的核销请求，确保核销完成后再解除 loading
            Promise.resolve(callback(rawStr)).then(() => resolve()).catch(() => resolve())
          } else {
            resolve()
          }
        }

        const isWeChat = /MicroMessenger/i.test(navigator.userAgent)
        if (!isWeChat) {
          this.$toast('请在企业微信或微信中打开使用扫码功能')
          resolve()
          return
        }

        // 1. 优先使用企业微信官方 JSSDK (@wecom/jssdk)
        if (ww && ww.scanQRCode) {
          let settled = false
          let fallbackTimer = null
          const clearFallback = () => {
            settled = true
            if (fallbackTimer) {
              clearTimeout(fallbackTimer)
              fallbackTimer = null
            }
          }
          const settleScan = () => {
            if (settled || finished) return
            settled = true
            if (fallbackTimer) {
              clearTimeout(fallbackTimer)
              fallbackTimer = null
            }
            tryWeixinBridge()
          }
          ww.scanQRCode({
            needResult: 1,
            scanType: ['qrCode']
          }).then((res) => {
            let resultStr = (res && (res.resultStr || res.scan_result || res.scanResult)) || ''
            if (resultStr) {
              clearFallback()
              handleResult(resultStr)
            } else {
              settleScan()
            }
          }).catch((err) => {
            const errMsg = (err && (err.errMsg || err.message || JSON.stringify(err))) || ''
            if (errMsg.includes('cancel')) {
              clearFallback()
              finished = true
              resolve()
              return
            }
            console.warn('ww.scanQRCode failed, trying WeixinJSBridge:', err)
            settleScan()
          })
          // 超时保护：ww.scanQRCode 若长时间不回调（未注册/卡死），降级到 WeixinJSBridge
          fallbackTimer = setTimeout(() => {
            settleScan()
          }, 3000)
          return
        }

        tryWeixinBridge()

        function tryWeixinBridge() {
          // 2. 尝试使用企业微信/微信内置 WeixinJSBridge
          if (typeof window.WeixinJSBridge !== 'undefined' && window.WeixinJSBridge.invoke) {
            window.WeixinJSBridge.invoke('scanQRCode', {
              needResult: 1,
              scanType: ['qrCode']
            }, (res) => {
              if (res && (res.err_msg === 'scanQRCode:ok' || res.errMsg === 'scanQRCode:ok')) {
                let raw = res.resultStr || res.scan_result || ''
                if (typeof raw === 'string' && (raw.startsWith('{') || raw.startsWith('['))) {
                  try {
                    const parsed = JSON.parse(raw)
                    if (parsed && parsed.scan_code && parsed.scan_code.scan_result) {
                      raw = parsed.scan_code.scan_result
                    }
                  } catch (e) {
                    console.warn('parse scan result error', e)
                  }
                }
                handleResult(raw)
              } else if (res && (res.err_msg || res.errMsg) && (res.err_msg || res.errMsg).includes('cancel')) {
                finished = true
                resolve()
              } else {
                tryWxSdk()
              }
            })
            return
          }
          tryWxSdk()
        }

        function tryWxSdk() {
          // 3. 尝试使用 weixin-js-sdk
          if (typeof wx !== 'undefined' && wx.scanQRCode) {
            wx.scanQRCode({
              needResult: 1,
              scanType: ['qrCode'],
              success: (res) => {
                handleResult(res.resultStr)
              },
              fail: (err) => {
                const errMsg = (err && (err.errMsg || JSON.stringify(err))) || ''
                if (errMsg.includes('cancel')) {
                  finished = true
                  resolve()
                  return
                }
                console.warn('wx.scanQRCode failed:', err)
                if (!finished) {
                  finished = true
                  this.$toast('调起摄像头失败，可直接使用微信/企微右上角【扫一扫】')
                  resolve()
                }
              }
            })
          } else {
            if (!finished) {
              finished = true
              this.$toast('当前环境未就绪，建议直接使用企业微信右上角【扫一扫】')
              resolve()
            }
          }
        }
      })
    },
    // 乘客手动确认上车：已移除，仅支持扫码后落库
    // 说明：上车状态只能通过扫描司机端动态乘车码产生，禁止手动确认。
    // 清除早拼注册数据后回到入口重新申请
    reregister () {
      this.$dialog.confirm({
        title: '注销早班账号',
        message: '该操作会删除你的早班拼车注册档案（不是解除绑定），删除后需重新提交注册申请。仅想更换司机请返回使用「取消绑定」。是否继续？'
      })
        .then(async () => {
          const uid = this.form.UserId || this.WXInfo.userid
          const result = await this.$request({
            url: this.$api.deleteWorkUserRegistration,
            method: 'DELETE',
            params: { UserId: uid }
          })
          if (result.success) {
            this.$toast('已清除，请重新注册')
            this.$router.replace('/work/login')
          } else if (result.message && String(result.message).includes('未找到')) {
            // 本就无早拼注册，直接去注册入口
            this.$toast('尚未注册，请先完成早拼申请')
            this.$router.replace('/work/login')
          } else {
            this.$toast(result.message || '操作失败')
          }
        })
        .catch(() => {})
    },
    // 乘客取消绑定司机
    cancleBind () {
      this.$dialog.confirm({
        title: '提示',
        message: '是否取消绑定？解绑后需重新选择司机才能拼车。审核1-3工作日。',
      })
        .then(async () => {
          let query = {
            Model: 'workuser',
            UserId: this.form.UserId
          }
          let data = {
            DepartTime: '',
            Way: '',
            LngLat: [],
            Distance: 0,
            DriverId: '',
            Effictive: false,
            Status: false
          }
          const result = await this.postUpDataOrCreate(query, data)
          if (result.success) {
            this.sendMessage('passengerCancleBind', this.form.DriverId, this.form)
            // 先本地复位，避免 getData 重新计算前按钮仍处于禁用状态
            this.bindBtn = false
            this.driverBtn = false
            this.$set(this.form, 'DriverId', '')
            this.$set(this.form, 'Effictive', false)
            this.$set(this.form, 'Status', false)
            this.$toast('已解除绑定，请重新选择司机并提交申请')
            this.getData()
          } else{
            this.$toast(result.message || '解除绑定失败，请稍后重试')
          }
        })
        .catch(() => {
          // on cancel
        })
    },
    sendMessage(type, userid, value) {
      let message = ''
      if (type === 'driverMake') {
        message = '消息通知：' +
        '\n\n日期：' + this.date +
        '\n司机：' + value.DriverName +
        '\n上车时间：' + value.DepartTime +
        '\n上车地点：' + value.Way +
        '\n\n今日早班行程已就绪，上车后请扫描司机出示的乘车码。\n\n' +
        '<a href="https://pinche.jafron.com/work/index">去扫码上车</a>'
      } else if (type === 'driverConfirm') {
        message = '消息通知：' +
        '\n\n您预约' + value.DateTime + '的早班拼车，司机已发车。'
      } else if (type === 'passengerCancle') {
        message = '消息通知：' +
        '\n\n日期：' + this.date +
        '\n乘客：' + value.Name +
        '\n\n请注意，乘客已取消您的早班拼车。'
      } else if (type === 'passengerBoard') {
        message = '消息通知：' +
        '\n\n日期：' + this.date +
        '\n乘客：' + value.Name +
        '\n上车时间：' + value.DepartTime +
        '\n上车地点：' + value.Way +
        '\n\n乘客已扫码上车，请在约定时间接上乘客。'
      } else if (type === 'passengerCancleBind') { // 乘客取消绑定，给司机发生消息
        message = '消息通知：' +
        '\n\n时间：' + this.$moment(new Date()).format('YYYY-MM-DD HH:mm') +
        '\n乘客：' + value.Name +
        '\n\n请注意，乘客已取消与您的绑定关系。'
      }
      this.postSendMessage(userid, message)
    },
    goTo (type, id) {
      if (type === 'bind') {
        this.$router.push('/work/bind?id=' + id)
      } else {
        this.$router.push('/work/audit')
      }
    },
    async onCalendarSelect (data) {
      this.date = this.$moment(data).format('YYYY-MM-DD')
      this.week = this.$moment(data).format('dddd')
      this.showDate = false
      if (this.form.Role === 'driver' && this.form.UserId) {
        await this.getWorkTravelApi(this.form.UserId)
        this.syncDriverTitle()
        this.$nextTick(() => {
          this.showTime = true
        })
      }
    },
    async onTime (time) {
      this.time = time
      this.showTime = false
      if (this.form.Role !== 'driver' || !this.form.UserId) return
      this.form.DepartTime = time
      try {
        const tasks = [
          this.$request({
            url: this.$api.postWorkUser,
            method: 'POST',
            params: { UserId: this.form.UserId },
            data: { DepartTime: time }
          })
        ]
        if (this.driverBtn && this.travelId) {
          tasks.push(this.postWorkTravel({ DepartTime: time }))
        }
        const results = await Promise.all(tasks)
        if (results.some(result => result && result.success === false)) {
          this.$toast((results.find(result => result && result.success === false) || {}).message || '发车时间保存失败')
          return
        }
        this.$toast('发车时间已更新')
      } catch (e) {
        this.$toast('发车时间保存失败')
        console.error('onTime error', e)
      }
    },
    findPassenger (arr) {
      let data = arr.find(item => {
        return item.UserId === this.form.UserId
      })
      this.passengerTravelStatus = data ? data.Status : null
    },
    // 根据行程ID加载行程详情及司机信息
    async loadTravelById(travelId, currentStatus) {
      try {
        const result = await this.$request({
          url: this.$api.getWorkTravel,
          method: 'GET',
          params: {
            _id: travelId
          }
        })
        if (result && result.data && result.data.length) {
          const data = result.data[0]
          this.travelId = data._id
          this.date = data.DateTime
          this.time = data.DepartTime
          this.week = this.$moment(data.DateTime).format('dddd')
          this.havingTravel = true
          this.bindBtn = true

          // 同步司机展示信息
          this.$set(this.form, 'DriverId', data.UserId)
          this.$set(this.form, 'DriverName', data.Name || '')
          this.$set(this.form, 'DriverPhone', data.Phone || '')
          this.$set(this.form, 'DriverAvatar', data.Avatar || '')
          this.$set(this.form, 'DriverCarName', data.CarName || '')
          this.$set(this.form, 'DriverCarNum', data.CarNum || '')
          this.$set(this.form, 'DriverCarSeat', data.CarSeat || '')
          this.$set(this.form, 'Way', data.Way || this.form.Way || '')

          if (currentStatus) {
            this.passengerTravelStatus = currentStatus
          } else {
            await this.findPassenger(data.passenger)
          }

          if (this.passengerTravelStatus === '已上车') {
            this.title = '今日已成功扫码上车'
            this.passengerBtn = true
          } else {
            this.title = '行程已就绪，请扫描司机乘车码上车'
            this.passengerBtn = false
          }
        }
      } catch (e) {
        console.error('loadTravelById error', e)
      }
    },
    // 乘客获取行程信息
    async getTravel(id) {
      const result = await this.$request({
        url: this.$api.getWorkTravel,
        method: 'GET',
        params: {
          UserId: id,
          Status: '已发布'
        }
      })
      if (result.data.length) {
        let data = result.data[0]
        await this.findPassenger(data.passenger)
        this.travelId = data._id
        this.date = data.DateTime
        this.time = data.DepartTime
        this.week = this.$moment(data.DateTime).format('dddd')
        this.havingTravel = true
        if (this.passengerTravelStatus === '已上车') {
          this.title = '今日已成功扫码上车'
          this.passengerBtn = true
        } else {
          this.title = '司机行程已就绪，请扫码上车'
          this.passengerBtn = false
        }
      } else {
        this.havingTravel = false
        this.passengerBtn = false
      }
    },
    // 获取司机拼车行程
    async getWorkTravelApi(id) {
      if (!id) return false
      this.travelLoading = true
      const queryDate = /^\d{4}-\d{2}-\d{2}$/.test(this.date) ? this.date : this.todayStr
      try {
        const result = await this.$request({
          url: this.$api.getWorkTravel,
          method: 'GET',
          params: {
            UserId: id,
            Status: '已发布',
            DateTime: queryDate
          }
        })
        const list = (result && result.data) || []
        if (list.length) {
          const data = list[0]
          this.travelId = data._id
          this.time = data.DepartTime
          this.date = data.DateTime
          this.week = this.$moment(data.DateTime).format('dddd')
          this.driverBtn = true
          if (data.passenger && data.passenger.length) {
            this.boardPerson = data.passenger
            this.refreshPassengerStatus(data.passenger)
          }
          this.syncDriverTitle()
          return true
        }

        this.driverBtn = false
        this.travelId = ''
        this.fillDefaultDepartDisplay()
        this.syncDriverTitle()
        return false
      } catch (e) {
        console.error('getWorkTravelApi error', e)
        this.driverBtn = false
        this.fillDefaultDepartDisplay()
        this.syncDriverTitle()
        return false
      } finally {
        this.travelLoading = false
      }
    },
    // 查询用户基础数据
    async getUserInfo() {
      const result = await this.$request({
        url: this.$api.getWorkUserInfo,
        method: 'GET',
        params: {
          UserId: this.form.UserId
        }
      })
      // 有效早拼注册必须是对象；[] / null 都视为未注册（兼容旧接口缺 data 时被 http 默认成 []）
      const data = result.data
      const hasWorkUser = data && typeof data === 'object' && !Array.isArray(data) && (data.UserId || data.Role)
      if (hasWorkUser) {
        this.form = data
        if (!this.form.Name && this.WXInfo.name) {
          this.form.Name = this.WXInfo.name
        }
      } else {
        // 未注册早班车的用户，默认作为乘客进入早班页面（允许直接扫码上车或选择司机）
        this.form.Role = 'passenger'
        if (this.WXInfo.name) {
          this.form.Name = this.WXInfo.name
        }
      }
    },
    // 获取已绑定的乘客列表
    getPassengerList() {
      return this.$request({
        url: this.$api.getPassengerListByDriverId,
        method: 'GET',
        params: {
          DriverId: this.form.UserId,
          Effictive: true,
          Status: true,
          Work: true
        }
      })
    },
    // 获取审核通过司机列表
    getWorkDriverList(data) {
      return this.$request({
        url: this.$api.getWorkDriverList,
        method: 'GET',
        params: data
      })
    },
    // 司机获取乘客申请绑定数据
    async getNeedBindData() {
      const result = await this.$request({
        url: this.$api.getPassengerListByDriverId,
        method: 'GET',
        params: {
          DriverId: this.form.UserId,
          Effictive: false,
          Work: true
        }
      })
      if (result.data.length > 0) {
        this.needBind = true
      }
    },
    // 获取早班乘客数据
    getWorkTravelFromPassenger(data) {
      return this.$request({
        url: this.$api.getWorkTravelFromPassenger,
        method: 'GET',
        params: data
      })
    },
    postWorkTravel (data) {
      return this.$request({
        url: this.$api.postWorkTravel,
        method: 'POST',
        params: {
          UserId: this.form.UserId,
          DateTime: this.date
        },
        data
      })
    },
    postUpDataOrCreate (query, data) {
      return this.$request({
        url: this.$api.postUpDataOrCreateApi,
        method: 'POST',
        params: query,
        data
      })
    },
    deleteTravel (id) {
      return this.$request({
        url: this.$api.deleteTravel,
        method: 'DELETE',
        params: {
          ParentsId: id
        }
      })
    },
    deleteWorkPassenger (id) {
      return this.$request({
        url: this.$api.deleteWorkPassengerApi,
        method: 'DELETE',
        params: {
          ParentsId: id,
          UserId: this.form.UserId
        }
      })
    },
    async postSendMessage(userid, message) {
      const result = await this.$request({
        url: this.$api.postSendMessageWX,
        method: 'POST',
        data: {
          'touser': userid,
          'msgtype': 'text',
          'agentid': this.$agentid,
          'text': { 'content': message }
        }
      })
      if (!result.success) {
        this.$toast(result.message)
      }
    }
  }
}
</script>

<style lang="less" scoped>
  .main {
    background-color: #F5F5F5;
    min-height: 100vh;
    padding-bottom: 24px;
    box-sizing: border-box;
  }
  .top-title {
    background: linear-gradient(135deg, #FFB82E 0%, #FEB013 100%);
    min-height: 84px;
    padding: 12px 14px 28px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    box-sizing: border-box;
  }
  .title-content {
    display: flex;
    align-items: center;
    flex: 1;
    overflow: hidden;
  }
  .top-actions {
    display: flex;
    align-items: center;
    gap: 6px;
    flex-shrink: 0;
    margin-left: 8px;
  }
  .title-text {
    color: #FFF5E4;
    font-size: 16px;
    text-shadow: 0px 2px 4px rgba(255, 158, 4, 0.5);
    font-weight: 600;
    padding-left: 8px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .content-body {
    margin: -16px 12px 12px 12px;
    line-height: 1.5;
    position: relative;
    z-index: 1;
  }
  .card {
    margin-bottom: 12px;
    background-color: #FFFFFF;
    padding: 14px 14px;
    border-radius: 8px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
  }
  .cell-flex {
    display: flex;
    align-items: center;
  }
  .cell-flex-center {
    margin-bottom: 10px;
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
  }
  .card-msg {
    background-color: rgba(254, 176, 19, 0.1);
    font-size: 12px;
    padding: 5px 6px;
    border-radius: 4px;
    color: #7B5200;
    margin-left: 8px;
  }
  .driver-card {
    background-color: #F9F9F9;
    border-radius: 4px;
    font-size: 13px;
    margin-bottom: 8px;
  }
  .driver-time {
    display: flex;
    align-items: center;
    border-bottom: 1px solid #D2D2D2;
    justify-content: space-between;
    padding-bottom: 12px;
  }
  .driver-way {
    display: flex;
    padding: 8px 0;
  }
  .driver-text {
    color: #F22222;
    font-size: 13px;
    text-align: center;
    margin-top: 8px;
  }
  .driver-list {
    background-color: #FFFFFF;
    margin-bottom: 8px;
    font-size: 14px;
    border-radius: 4px;
  }
  .page-loading,
  .list-loading {
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 48px 0;
    background: #FFFFFF;
    border-radius: 8px;
    margin-bottom: 8px;
  }
  .list-empty {
    background: #FFFFFF;
    border-radius: 8px;
    padding: 12px 0;
    margin-bottom: 8px;
  }
  .driver-info {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 12px;
  }
  .driver-bottom {
    padding: 12px;
    border-top: 1px solid #D2D2D2;
  }
  .passenger {
    background-color: #FFFFFF;
    padding: 8px 8px;
    margin: 8px 0;
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-radius: 4px;
    font-size: 15px;
  }
  .passenger-way {
    display: flex;
  }
  /deep/ .van-search {
    padding: 10px 0;
  }
  /deep/ .van-search__content {
    background-color: #FFFFFF;
  }
  .driverlist-way {
    background-color: #FFFFFF;
    padding: 12px;
  }
  /deep/ .driver-info .van-button {
    height: 40px;
  }
  /deep/ .top-title .van-button {
    border-color: rgba(255, 255, 255, 0.85);
    color: #FFFFFF;
    background: rgba(255, 255, 255, 0.15);
    padding: 0 10px;
    min-width: auto;
    backdrop-filter: blur(4px);
  }
  .passenger-status {
    margin-left: 8px;
    color: #FFFFFF;
    border-radius: 25px;
    font-size: 12px;
    padding: 0 12px;
  } 

  .passenger-action-box,
  .driver-action-box {
    margin-top: 14px;
  }
  .driver-wait-tip {
    text-align: center;
    color: #888;
    font-size: 13px;
    line-height: 1.5;
    margin-bottom: 12px;
    padding: 0 8px;
  }
  .driver-dayoff-row {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 12px 14px;
    margin-bottom: 12px;
    background: #FFF8EB;
    border-radius: 10px;
  }
  .driver-dayoff-label {
    font-size: 14px;
    font-weight: 600;
    color: #333;
  }
  .driver-dayoff-desc {
    font-size: 12px;
    color: #999;
    margin-top: 4px;
  }
  .driver-dayoff-tip {
    color: #C97A00;
  }
  .driver-depart-settings {
    margin-top: 12px;
  }
  .settings-title {
    font-size: 16px;
    font-weight: 600;
    margin-bottom: 12px;
  }
  .skip-dates-section {
    margin-top: 4px;
  }
  .skip-dates-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 10px;
  }
  .skip-dates-title {
    font-size: 14px;
    font-weight: 600;
    color: #333;
  }
  .skip-dates-list {
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
  }
  .skip-date-tag {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    padding: 6px 10px;
    background: #F5F5F5;
    border-radius: 16px;
    font-size: 12px;
    color: #555;
  }
  .skip-date-remove {
    color: #999;
    font-size: 14px;
  }
  .skip-dates-empty {
    font-size: 12px;
    color: #999;
    line-height: 1.5;
  }
  .main-scan-btn {
    height: 44px !important;
    font-size: 15px !important;
    font-weight: 600 !important;
    box-shadow: 0 3px 10px rgba(254, 176, 19, 0.35);
  }
  .boarded-btn {
    height: 44px !important;
    font-size: 15px !important;
    font-weight: 600 !important;
    box-shadow: 0 3px 10px rgba(7, 193, 96, 0.3);
  }
  .sub-action-row {
    display: flex;
    justify-content: space-between;
    gap: 10px;
    margin-top: 10px;
  }
  .sub-action-btn {
    flex: 1;
    height: 36px !important;
    line-height: 36px !important;
    font-size: 13px !important;
  }
  .sub-manual-btn {
    color: #555555 !important;
    border-color: #DDDDDD !important;
  }
  .action-btn-row {
    margin: 4px 0;
  }
  .action-btn {
    font-size: 13px !important;
    padding: 0 4px !important;
    height: 38px !important;
    line-height: 38px !important;
  }
  .btn-highlight {
    font-weight: 600;
  }
  .qr-modal-popup {
    border-radius: 16px;
    overflow: hidden;
  }
  .qr-modal-container {
    padding: 24px 16px 16px;
    text-align: center;
    background: #FFFFFF;
  }
  .qr-modal-title {
    font-size: 17px;
    font-weight: bold;
    color: #333333;
    margin-bottom: 6px;
  }
  .qr-modal-instruction {
    font-size: 12px;
    color: #888888;
    margin-bottom: 12px;
  }
  .qr-code-box {
    display: flex;
    justify-content: center;
    align-items: center;
    min-height: 180px;
    margin: 0 auto 10px;
  }
  .qr-loading-wrapper {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 180px;
  }
  .qr-code-img {
    width: 180px;
    height: 180px;
    border-radius: 8px;
    border: 1px solid #EEEEEE;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
  }
  .qr-error-text {
    color: #999999;
    font-size: 13px;
  }
  .qr-countdown-bar {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    background: #FFF8EB;
    color: #7B5200;
    font-size: 12px;
    padding: 5px 12px;
    border-radius: 12px;
    margin-bottom: 14px;
  }
  .countdown-highlight {
    font-weight: bold;
    color: #FF9E04;
    margin: 0 3px;
  }
  .qr-passenger-section {
    border-top: 1px dashed #E5E5E5;
    padding-top: 12px;
    text-align: left;
  }
  .qr-passenger-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 8px;
  }
  .section-title {
    font-size: 13px;
    font-weight: 600;
    color: #333333;
  }
  .section-badge {
    font-size: 12px;
    color: #FF9E04;
    font-weight: bold;
  }
  .qr-passenger-list {
    max-height: 140px;
    overflow-y: auto;
  }
  .qr-passenger-item {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 6px 0;
    border-bottom: 1px solid #F5F5F5;
  }
  .qr-passenger-meta {
    margin-left: 8px;
  }
  .passenger-name {
    font-size: 13px;
    font-weight: 500;
    color: #333333;
  }
  .passenger-way {
    font-size: 11px;
    color: #999999;
    max-width: 150px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .qr-no-passenger {
    text-align: center;
    color: #999999;
    font-size: 12px;
    padding: 12px 0;
  }
</style>
